(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vivanoura-sac-vide-fr"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-vsf-section]').forEach((root)=>{if(root.dataset.vsfReady)return;root.dataset.vsfReady='true';const mainImage=root.querySelector('.vsf__main-image');const gallery=root.querySelector('.vsf__gallery');const thumbButtons=Array.from(root.querySelectorAll('[data-vsf-image]'));const showImage=(url)=>{if(!mainImage||!url)return;mainImage.src=url;mainImage.srcset='';thumbButtons.forEach((item)=>item.classList.toggle('is-active',item.dataset.vsfImage.split('?')[0]===url.split('?')[0]));};thumbButtons.forEach((button)=>button.addEventListener('click',()=>showImage(button.dataset.vsfImage)));const variants=JSON.parse(root.querySelector('[data-vsf-variants]')?.textContent||'[]');const form=root.querySelector('.vsf__form');if(!form||!variants.length)return;const formatter=new Intl.NumberFormat(document.documentElement.lang||'fr-FR',{style:'currency',currency:root.dataset.currency});const selectedValues=()=>Array.from(form.querySelectorAll('.vsf__option input:checked')).map((input)=>input.value);const findVariant=(values)=>variants.find((item)=>item.options.every((option,index)=>option===values[index]));const updatePackCards=(size)=>{form.querySelectorAll('[data-vsf-option="2"] .vsf__choice').forEach((card)=>{const input=card.querySelector('input');const variant=variants.find((item)=>item.options[0]===size&&item.options[1]===input.value);const price=card.querySelector('[data-vsf-pack-price]');const image=card.querySelector('[data-vsf-pack-image]');if(price)price.textContent=variant?formatter.format(variant.price/100):'';if(image){image.innerHTML=variant&&variant.image?`<img src="${variant.image}" alt="" loading="lazy">`:'';}card.classList.toggle('is-unavailable',!variant||!variant.available);input.disabled=!variant;});};const update=(userTriggered=false)=>{const values=selectedValues();updatePackCards(values[0]);let variant=findVariant(values);if(!variant){const fallback=variants.find((item)=>item.options[0]===values[0]&&item.available);if(fallback){const packInput=Array.from(form.querySelectorAll('[data-vsf-option="2"] input')).find((input)=>input.value===fallback.options[1]);if(packInput)packInput.checked=true;variant=fallback;}}if(!variant)return;form.querySelector('[data-vsf-variant-id]').value=variant.id;root.querySelectorAll('[data-vsf-option-summary]').forEach((summary)=>{const input=form.querySelector(`[data-vsf-option="${summary.dataset.vsfOptionSummary}"] input:checked`);summary.textContent=input?input.value:'';});const formatted=formatter.format(variant.price/100);const price=root.querySelector('[data-vsf-price]');if(price)price.textContent=formatted;const buttonPrice=form.querySelector('[data-vsf-submit-price]');if(buttonPrice)buttonPrice.textContent=formatted;const sku=form.querySelector('[data-vsf-sku]');if(sku)sku.textContent=variant.sku||'—';const stock=form.querySelector('[data-vsf-stock]');if(stock){stock.textContent=variant.available?'En stock':'Épuisé';stock.style.color=variant.available?'#18834b':'#b42318';}const submit=form.querySelector('[data-vsf-submit]');const buyNow=form.querySelector('[data-vsf-buy-now]');const submitLabel=form.querySelector('[data-vsf-submit-label]');submit.disabled=!variant.available;if(buyNow)buyNow.disabled=!variant.available;if(submitLabel)submitLabel.textContent=variant.available?'Ajouter au panier':root.dataset.soldLabel;if(variant.image)showImage(variant.image);if(userTriggered&&gallery){requestAnimationFrame(()=>gallery.scrollIntoView({behavior:'smooth',block:'start'}));}};form.querySelectorAll('.vsf__option input').forEach((input)=>input.addEventListener('change',()=>update(true)));update(false);});

  } catch(e) { console.error(e); }
})();
})();
